const initialState = {
  polls: [],
  isCreatePollFormVisible: false,
  editPollsIds: new Set(),
  answeredPollIds: new Set(),
}

export default ({ actionNames }) =>
  (state = initialState, action = undefined) => {
    switch (action.type) {
      case actionNames.FETCH_POLLS_SUCCESS: {
        return {
          ...state,
          polls: action.polls,
        }
      }
      case actionNames.TOGGLE_CREATE_POLL_FORM_VISIBILITY: {
        return {
          ...state,
          isCreatePollFormVisible: !state.isCreatePollFormVisible,
        }
      }
      case actionNames.SET_ANSWERED_POLL_ID: {
        const answeredPollIds = new Set(state.answeredPollIds)
        answeredPollIds.add(action.pollId)

        return {
          ...state,
          answeredPollIds,
        }
      }
      case actionNames.TOGGLE_EDIT_POLL: {
        const { pollId } = action
        const editPollsIds = new Set(state.editPollsIds)
        const setAction = editPollsIds.has(pollId) ? 'delete' : 'add'
        editPollsIds[setAction](pollId)

        return {
          ...state,
          editPollsIds,
        }
      }
      default:
        return state
    }
  }
